import Axios from 'axios';

const service = 'Configurations';

export const currencyList = async () => {
  const { data } = await Axios.get(`/${service}/api/Currency/List`);
  return data;
};
